import { useEffect } from 'react';

type Props = {
  src: string;
  alt?: string;
  onClose: () => void;
};

/**
 * 图片灯箱：点击缩略图后打开，最大化展示
 * - 半透明黑色背景
 * - ESC / 点击背景 / ✕ 关闭
 * - 阻止 body 滚动
 */
export default function ImageLightbox({ src, alt, onClose }: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return (
    <div className="lightbox" onClick={onClose} role="dialog" aria-label="图片详情">
      <button
        className="lightbox-close"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        aria-label="关闭"
      >
        ✕
      </button>
      <img
        src={src}
        alt={alt ?? '图片'}
        className="lightbox-img"
        onClick={(e) => e.stopPropagation()}
      />
      {alt && <div className="lightbox-caption">{alt}</div>}
    </div>
  );
}